import { useEffect } from 'react';

import { acquirePolling, useGeneration } from '../../state/generation.js';
import { useWorkspace } from '../../state/workspace.js';

/**
 * Binds the generation store to the open project and, while `active`, polls
 * the generation list (every 2 s while this project's tab is on screen, every 5 s
 * while it is a background tab: it never stops, so waiting items still notify).
 */
export function useGenerationFeed(active = true): void {
  const projectId = useWorkspace((s) => s.projectId);
  useEffect(() => {
    void useGeneration.getState().setProject(projectId);
  }, [projectId]);
  useEffect(() => {
    if (!active || projectId === null) return;
    return acquirePolling();
  }, [active, projectId]);
}
